import { useState } from 'react';
import PropTypes from 'prop-types';
import EmailValidation from 'Components/EmailValidation';
import Heading from 'Components/Heading';
import ProgressBar from 'Components/ProgressBar';

const ValidateEmail = ({
  applicationConfig,
  failureMessage,
  looped,
  strings,
  transitionTo,
  uim,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const { cta1, loginProviders, disallowRegistration } = applicationConfig;
  const showSpecialHeading = loginProviders.length === 1;

  const handleSubmit = () => setSubmitting(true);

  return (
    <div>
      {submitting && <ProgressBar />}

      {showSpecialHeading ? (
        <Heading cta1={cta1 || strings.cta1} cta2={strings.cta2} />
      ) : (
        <h1 className="page-heading">{strings.emailHeading}</h1>
      )}

      <EmailValidation
        autofocus
        continueText={strings.continue}
        emailText={strings.email}
        errorText={strings.errorMessage}
        failureMessage={failureMessage}
        looped={looped}
        onSubmit={handleSubmit}
        transitionTo={transitionTo}
        uim={uim}
        validText={strings.validEmail}
        disallowRegistration={disallowRegistration}
      />
    </div>
  );
};

ValidateEmail.propTypes = {
  applicationConfig: PropTypes.object.isRequired,
  failureMessage: PropTypes.func.isRequired,
  looped: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  strings: PropTypes.object.isRequired,
  transitionTo: PropTypes.func.isRequired,
  uim: PropTypes.object.isRequired,
};

export default ValidateEmail;
